import { useMessageStore } from "@/state/stores";
import { extractDeploymentUrl } from "@/utils";
import { useMemo } from "react";
import { useShallow } from "zustand/shallow";

export function useLatestDeploymentUrl(): string | null {
  const deploymentStatus = useMessageStore(
    useShallow((state) => state.deploymentStatus),
  );

  return useMemo(() => {
    // Get all deployment files from all messages
    const allDeploymentFiles = Object.values(deploymentStatus).flat();

    if (allDeploymentFiles.length === 0) {
      return null;
    }

    // Find the most recent completed deployment with a URL
    const sortedFiles = allDeploymentFiles
      .filter(
        (file) =>
          file.status === "completed" && file.content?.includes("fp.dev"),
      )
      .sort(
        (a, b) =>
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
      );

    if (sortedFiles.length === 0) {
      return null;
    }

    return extractDeploymentUrl(sortedFiles[0].content);
  }, [deploymentStatus]);
}
